var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.826,
    height: 20.263,
    viewBox: "0 0 19.826 20.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M11.8,8.58,19.18,0H17.431L11.022,7.45,5.9,0H0L7.74,11.265l-7.74,9H1.749L8.517,12.4l5.406,7.867h5.9L11.8,8.58ZM9.4,11.364l-.784-1.122L2.379,1.317H5.066L10.1,8.52l.784,1.122,6.546,9.363H14.745L9.4,11.365Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9052faee6698751ac0e7e2a06b014d3e.svg";
export { ForwardRef as ReactComponent };